"use client";
import { TenantProvider } from "@/lib/tenant/context";
import { getTenantApiBaseAddress, type PortalTenant } from "@/lib/tenant/helpers";
import { ChunkErrorReloadHandler } from "@/shared/ChunkErrorReloadHandler";
import { MainAppLayoutProvider } from "@/shared/Layout/MainAppLayoutProvider";
import { ServerActionReloadHandler } from "@/shared/ServerActionReloadHandler";
import { CssBaseline } from "@mui/material";
import { auth, configureApi } from "@osn/auth";
import { ConfirmDialogProvider, ToastrProvider } from "@osn/react-components";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import React from "react";

const Providers = ({ children, tenant }: { children: React.ReactNode; tenant: PortalTenant }) => {
  const firebaseTenantId = tenant.firebaseTenantId;
  const apiBaseAddress = getTenantApiBaseAddress(tenant);

  if (apiBaseAddress) {
    configureApi({ baseAddress: apiBaseAddress });
  }

  React.useEffect(() => {
    auth.tenantId = firebaseTenantId;

    if (apiBaseAddress) {
      configureApi({ baseAddress: apiBaseAddress });
    }
  }, [firebaseTenantId, apiBaseAddress]);

  return (
    <TenantProvider tenant={tenant}>
      <MainAppLayoutProvider>
        <NuqsAdapter>
          <CssBaseline />
          <ToastrProvider />
          <ConfirmDialogProvider>{children}</ConfirmDialogProvider>
        </NuqsAdapter>
        <ServerActionReloadHandler />
        <ChunkErrorReloadHandler />
      </MainAppLayoutProvider>
    </TenantProvider>
  );
};

export { Providers };
